module.exports = __webpack_public_path__ + "static/media/galerija_2021 (33).739b0c84.jpg";